$('.scroll-on-change').on('change', function() {

    // Get selected identifier
    let hash = '#' + this.value;

    // If identifier exists
    if ($(hash)[0]) {

        // Scroll to identifier
        $('html, body').animate({
            scrollTop: $(hash).offset().top
        }, 300, function () {
            // when done, add hash to url
            // (default click behaviour)
            window.location.hash = hash;
        });
    }
});